var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRowing(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "30pt",
    height: "30pt",
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "surface1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      stroke: "rgb(9.411765%,10.588235%,11.764706%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 42.683333 43.191667 L 33.183333 37.25 L 24.875 43.191667 C 24.875 43.191667 22.5 43.183333 22.5 38.258333 C 22.5 32.683333 25.558333 27.758333 26.766667 26.033333 C 27.033333 25.65 27.541667 25.575 27.933333 25.825 L 37.933333 32.5 ",
    transform: "matrix(0.46875,0,0,0.46875,0,0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      stroke: "rgb(9.411765%,10.588235%,11.764706%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 32 21.816667 C 33.966667 21.816667 35.566667 20.216667 35.566667 18.25 C 35.566667 16.283333 33.966667 14.683333 32 14.683333 C 30.033333 14.683333 28.433333 16.283333 28.433333 18.25 C 28.433333 20.216667 30.033333 21.816667 32 21.816667 Z M 32 21.816667 ",
    transform: "matrix(0.46875,0,0,0.46875,0,0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      stroke: "rgb(9.411765%,10.588235%,11.764706%)",
      strokeOpacity: 1,
      strokeMiterlimit: 10
    },
    d: "M 37.933333 47.933333 L 51 47.933333 L 54.566667 55.066667 ",
    transform: "matrix(0.46875,0,0,0.46875,0,0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      stroke: "rgb(9.411765%,10.588235%,11.764706%)",
      strokeOpacity: 1,
      strokeMiterlimit: 10
    },
    d: "M 9.433333 55.066667 L 13 47.933333 L 39.125 47.933333 ",
    transform: "matrix(0.46875,0,0,0.46875,0,0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      stroke: "rgb(9.411765%,10.588235%,11.764706%)",
      strokeOpacity: 1,
      strokeMiterlimit: 10
    },
    d: "M 51 36.066667 L 54.566667 40.816667 L 51 47.933333 ",
    transform: "matrix(0.46875,0,0,0.46875,0,0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      stroke: "rgb(9.411765%,10.588235%,11.764706%)",
      strokeOpacity: 1,
      strokeMiterlimit: 10
    },
    d: "M 46.25 36.066667 L 51 26.558333 ",
    transform: "matrix(0.46875,0,0,0.46875,0,0)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRowing);
export default __webpack_public_path__ + "static/media/rowing.45196cc91c879ee7af82da88c005a94a.svg";
export { ForwardRef as ReactComponent };